import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-numeric-field',
  templateUrl: './numeric-field.component.html',
  styleUrls: ['./numeric-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NumericFieldComponent,
    },
  ],
})
export class NumericFieldComponent implements ControlValueAccessor {
  @Input() public maxValue = 99;
  @Input() public minValue = 1;
  @Input() public value = 1;
  @Input() public editable = true;

  private _touched = false;
  private _disabled = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onChange = (value: number) => {};

  public onTouched = () => {};

  public writeValue(value: number): void {
    this.value = value;
  }

  public registerOnChange(onChange: (value: number) => void): void {
    this.onChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  public markAsTouched() {
    if (!this._touched) {
      this.onTouched();
      this._touched = true;
    }
  }

  public setDisabledState(disabled: boolean) {
    this._disabled = disabled;
  }

  public countUp() {
    if (this.editable) {
      this.markAsTouched();
      if (this.maxValue > this.value && !this._disabled) {
        this.value++;
        this.onChange(this.value);
      }
    }
  }

  public countDown() {
    if (this.editable) {
      this.markAsTouched();
      if (this.minValue < this.value && !this._disabled) {
        this.value--;
        this.onChange(this.value);
      }
    }
  }
}
